import type { Dispatch, SetStateAction } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { EditorState } from "../connectorManagerHelpers";

export const WordPressSelfHostedFields = ({
  editor,
  setEditor,
}: {
  editor: EditorState;
  setEditor: Dispatch<SetStateAction<EditorState>>;
}) => (
  <div className="space-y-3">
    <div className="space-y-2">
      <Label htmlFor="connector-wpsh-site">WordPress site URL</Label>
      <Input
        id="connector-wpsh-site"
        type="url"
        value={editor.wpShSiteUrl}
        onChange={(e) => setEditor((s) => ({ ...s, wpShSiteUrl: e.target.value }))}
        placeholder="https://yourblog.com"
      />
      <p className="text-xs text-muted-foreground">
        Enter the full URL of your self-hosted WordPress site (e.g.{" "}
        <code>https://yourblog.com</code>). Don&apos;t include <code>/wp-admin</code> or{" "}
        <code>/wp-json</code> — we add those for you.
      </p>
    </div>
    <div className="grid gap-2 sm:grid-cols-2">
      <div className="space-y-2">
        <Label htmlFor="connector-wpsh-user">WordPress username</Label>
        <Input
          id="connector-wpsh-user"
          value={editor.wpShUsername}
          onChange={(e) => setEditor((s) => ({ ...s, wpShUsername: e.target.value }))}
          placeholder="your-wp-username"
          autoComplete="username"
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="connector-wpsh-secret">
          Application Password {editor.connector ? "(leave blank to keep)" : ""}
        </Label>
        <Input
          id="connector-wpsh-secret"
          type="password"
          autoComplete="new-password"
          value={editor.secretValue}
          onChange={(e) => setEditor((s) => ({ ...s, secretValue: e.target.value }))}
          placeholder="xxxx xxxx xxxx xxxx xxxx xxxx"
        />
      </div>
    </div>
    <div className="rounded-md border border-dashed border-border bg-muted/30 p-3 text-xs text-muted-foreground">
      <p className="mb-1 font-medium text-foreground">How to generate an Application Password</p>
      <ol className="list-decimal space-y-0.5 pl-4">
        <li>
          In wp-admin, go to <strong>Users → Profile</strong> (or your user&apos;s profile page).
        </li>
        <li>
          Scroll to <strong>Application Passwords</strong>, name it <em>Excerptus</em>, and click{" "}
          <strong>Add New Application Password</strong>.
        </li>
        <li>
          Copy the generated password (shown once — spaces are fine, we strip them) and paste it above.
        </li>
      </ol>
      <p className="mt-2">
        Posts are created as drafts so you can review and publish from wp-admin. Use the
        connector&apos;s <strong>Test</strong> button after saving to confirm the credentials work.
      </p>
    </div>
  </div>
);
